import React from 'react'
import EditPostContainer, {
  CommonContainerProps
} from 'containers/EditPostContainer'
import { Container } from './TitleDescriptionPage.style'
import TextArea from 'components/Inputs/TextArea'
import DefaultInput from 'components/Inputs/DefaultInput'
import ErrorText from 'components/Text/ErrorText'

interface SelectionType {
  title: string
  description: string
  changed: boolean
}

interface TitleDescriptionPageProps
  extends CommonContainerProps<SelectionType> {
  initTitle?: string
  initDescription?: string
}

export default class TitleDescriptionPage extends React.Component<
  TitleDescriptionPageProps
> {
  state: {
    enteredTitle: string
    enteredDescription: string
  } = {
    enteredTitle: this.props.initTitle as string,
    enteredDescription: this.props.initDescription as string
  }

  render() {
    return (
      <EditPostContainer
        progressValue={74}
        title='Add Title &amp; Description'
        {...this.props}
        onNext={() => {
          return this.props.onNext?.({
            title: this.state.enteredTitle,
            description: this.state.enteredDescription,
            changed: this.props.initTitle !== this.state.enteredTitle
             || this.props.initDescription !== this.state.enteredDescription
          })
        }}
        isNextAvailable={
          !!this.state.enteredTitle && !!this.state.enteredDescription
            ? this.state.enteredTitle.length >= 5 &&
              this.state.enteredDescription.length >= 15
            : false
        }
      >
        <Container>
          {!!this.state.enteredTitle &&
          this.state.enteredTitle.length > 0 &&
            this.state.enteredTitle.length < 5 && (
              <ErrorText>You must enter at least 5 characters to continue</ErrorText>
            )}

          <DefaultInput
            placeholder={'Type at least 5 characters'}
            title='Listing Title'
            onChange={({ target }) => {
              this.setState({
                enteredTitle: target.value
              })
            }}
            defaultValue={this.state.enteredTitle}
          />
          {!!this.state.enteredDescription &&
          this.state.enteredDescription.length > 0 &&
            this.state.enteredDescription.length < 15 && (
              <ErrorText>You must enter at least 15 characters to continue</ErrorText>
            )}
          <TextArea
            placeholder={'Type at least 15 characters'}
            title='Listing Description'
            onChange={({ target }) => {
              console.log(target.value)
              this.setState({
                enteredDescription: target.value
              })
            }}
            defaultValue={this.state.enteredDescription}
          />
        </Container>
      </EditPostContainer>
    )
  }
}
